<template>
    <div class="context">
        <div class="header">
            <div class="title">病种列表</div>
            <div class="btn_box">
                <div class="btn nomal_btn" @click="addData">
                    <i class="el-icon-plus"></i>
                    新建病种
                </div>
                <div class="btn nomal_btn" @click="openCommon">
                    <!--<i class="el-icon-plus"></i>-->
                    默认周期
                </div>
            </div>
        </div>
        <div class="card_table" ref="dragCard">
            <el-card shadow="never"
                     v-for="(item , index) in tableList"
                     :key="index"
                     class="card_item sort_card">
                <div class="btn_box">
                    <div class="icon" @click="editData(item)">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="编辑"
                                    placement="top">
                            <i class="el-icon-edit-outline"></i>
                        </el-tooltip>
                    </div>
                    <div class="icon" @click="delRow(item)">
                        <el-tooltip class="item"
                                    effect="dark"
                                    content="删除"
                                    placement="top">
                            <i class="el-icon-delete table_del_btn"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div class="p_item">
                    <div class="title">名字：</div>
                    <div class="main_box">{{item.name}}</div>
                </div>
                <div class="p_item">
                    <div class="title">是否审批：</div>
                    <div class="main_box">{{item.approved | showApproved}}</div>
                </div>
                <div class="p_item" v-for="(item1, index1) in item.stage_list" :key="index1">
                    <div class="lang_title">{{item1.name}},总计{{item1.days}}天:</div>
                    <div class="main_box">
                        <div v-for="(items, indexs) in item1.cycle_list"
                             :key="indexs"
                             :style="changeBackgroundColor(indexs)"
                             class="tag_item">
                            {{items.name}}：{{items.days}}天
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import Sortable from "sortablejs";
    import {clone} from "@/global/utils";

    export default {
        name: "tableView",
        data() {
            return {
                tableList: [],

                changeSort: false, // 是否可以拖拽
                sortable: null, // 拖拽
            }
        },
        computed: {
            ...mapState('comInformationData', [
                'colorList'
            ])
        },
        filters: {
            showApproved(val) {
                return val == 1 ? '是' : val == 2 ? '否' : ''
            }
        },
        mounted() {
            this.getList();

        },
        methods: {
            ...mapMutations('comInformationData', {
                setAllIllData: 'setAllIllData',
            }),
            ...mapMutations('manageData', {
                setIllData: 'setIllData',
            }),
            addData() {
                this.setIllData(null);
                this.$emit('changeTopTab', 'addView')
            },
            openCommon() {
                this.$emit('changeTopTab', 'commonIll')
            },
            delRow(row) {
                this.$confirm('确定要删除该病种么？').then(() => {
                    this.httpDel(`/tumour/${row.tumour_id}`).then(res => {
                        this.$message.success('删除成功！');
                        this.getList();
                    })
                }).catch(() => {
                })
            },
            editData(row) {
                this.httpGet(`/tumour/${row.tumour_id}`).then(res => {
                    this.setIllData(res.data);
                    this.$emit('changeTopTab', 'addView')
                })
            },

            changeBackgroundColor(index) {
                let style = 'background:' + this.colorList[index];
                return style
            },
            getList() {
                this.httpGet('/tumour').then(res => {
                    this.tableList = res.data;
                    this.setAllIllData(clone(res.data));
                    this.rowDrop()
                })
            },


            rowDrop() {
                const tbody = this.$refs.dragCard;
                const _this = this;
                //  指定父元素下可被拖拽的子元素
                this.sortable = Sortable.create(tbody, {
                    draggable: ".sort_card", //  指定父元素下可被拖拽的子元素
                    // disabled: this.changeSort, // 是否开启拖拽
                    onEnd({newIndex, oldIndex}) {
                        console.log(newIndex, oldIndex, '拖拽成功');
                        const currRow = _this.tableList.splice(oldIndex, 1)[0];
                        _this.tableList.splice(newIndex, 0, currRow);
                        const newArray = _this.tableList.slice(0);
                        _this.tableList = [];
                        _this.$nextTick(() => {
                            _this.tableList = newArray;
                            _this.pushSort()
                        })
                    }
                });
            },
            pushSort() {
                let sort = [];
                this.tableList.map(v => {
                    sort.push(v.tumour_id)
                });
                this.httpPost('/tumour/update_order', sort)
            },
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            .title {
                padding-right: 20px;
            }
            .btn_box {
                display: flex;
                .btn {
                    border: 1px solid $btn_border;
                    margin: 10px 10px 0;
                }
            }
        }

        .card_table {
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            width: 100%;
            height: calc(100% - 50px);
            box-sizing: border-box;
            padding: 5px;
            overflow: hidden;
            overflow-y: auto;

            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            .card_item {
                width: 370px;
                min-height: 160px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                overflow: hidden;
                overflow-y: auto;
                &:hover {
                    .btn_box {
                        display: flex;
                    }
                }
                .btn_box {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    z-index: 9;
                    cursor: pointer;
                    display: none;
                    /*display: flex;*/
                    .icon {
                        width: 25px;
                        height: 25px;
                        background: #ddd;
                        border-radius: 50%;
                        line-height: 25px;
                        text-align: center;
                        margin-right: 5px;
                        i {
                            font-size: 1rem;
                        }
                    }
                }

                .p_item {
                    width: 100%;
                    display: flex;
                    padding: 0 5px;
                    font-size: 0.875rem;
                    line-height: 30px;
                    .title {
                        flex: 0 0 50px;
                        color: #8d8d8d;
                        white-space: nowrap;
                    }
                    .lang_title {
                        flex: 0 0 90px;
                        color: #8d8d8d;
                        white-space: nowrap;
                    }
                    .main_box {
                        flex: 1;
                        display: flex;
                        flex-wrap: wrap;
                        .tag_item {
                            width: 90px;
                            line-height: 30px;
                            text-align: center;
                            border-bottom: 1px solid #b2b2b2;
                        }
                    }
                }
            }
        }
    }
</style>